import React from 'react';
import SuperAdminDashboard from './SuperAdminDashboard';

const TeamDashboard = ({ user, userData }) => {
  return <SuperAdminDashboard mode="team" user={user} userData={userData} />;
};

export default TeamDashboard;
